import { FormControlLabel, Box } from '@mui/material';
import { RiPulseFill } from 'react-icons/ri';
import { WsColors, WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

interface PulseIconTextProps {
  text: string | JSX.Element;
  hover?: string;
}
const PulseIconText = ({ text, hover }: PulseIconTextProps) => (
  <FormControlLabel
    control={
      <Box pl={1} pt={0.2}>
        <RiPulseFill color={WsColors.TheBlues500} />
      </Box>
    }
    label={
      <Box pl={1}>
        <WsTypography
          variant={WsTypoVariants.BODY2}
          color={WsTypoColors.BLACK}
          cursor="pointer"
          hoverText={hover}
        >
          {text}
        </WsTypography>
      </Box>
    }
  />
);
export default PulseIconText;
